import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class ShareDataService {

  private info = new BehaviorSubject({});
  currentInfo = this.info.asObservable();

  constructor() { }

  share(dataParam: any) {
    this.info.next(dataParam)
  }

}